import { render, staticRenderFns } from "./SelectAir.vue?vue&type=template&id=470ea08e"
import script from "./SelectAir.vue?vue&type=script&lang=ts"
export * from "./SelectAir.vue?vue&type=script&lang=ts"
import style0 from "./SelectAir.vue?vue&type=style&index=0&id=470ea08e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports